let accessToken
const obj = JSON.parse(sessionStorage.getItem("authUser"));
if (obj && obj.accessToken) {
  accessToken = "Bearer " + obj.accessToken
} else {
  accessToken = ""
}
export default accessToken
